module.exports = __webpack_public_path__ + "static/media/bottle_1.9dbe3849.png";